module.exports = __webpack_public_path__ + "static/img/today_best_team.0175e9bb.png";